<!-- title -->
<app-modal-title
  [title]="'pages.landingPage.saveAsTemplate' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex-center tw-flex-col">
          <!-- title -->
          <form-field
            [(value)]="model.title"
            class="tw-w-full"
            [control]="form?.get('title')"
            label="common.title"
          >
          </form-field>
        </div>
        <div class="tw-mb-5">
          <!-- isPublicTemplate -->
          <mat-slide-toggle
            formControlName="isPublicTemplate"
            [(ngModel)]="model.isPublicTemplate"
          >
            {{ "common.isPublic" | translate }}
          </mat-slide-toggle>
        </div>
        <div class="tw-flex-center tw-flex-col">
          <file-uploader
            #fileUploader
            [label]="'pages.landingPage.selectTemplatePreview' | translate"
            [control]="form?.get('templatePreview')"
            class="tw-w-[275px]"
            (valueChange)="getFile($event)"
            acceptFile=".jpeg,.png,.jpg"
            [maxFileSize]="1"
            sizeType="mb"
            (onErrorFile)="showErrorDialog($event)"
          >
          </file-uploader>

          <app-show-images
            *ngIf="imageUrl"
            class="tw-mt-1"
            [src]="imageUrl"
          ></app-show-images>
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [btnType]="'submit'"
      [isEdit]="false"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
